import * as React from "react";
import PropTypes from "prop-types";
import { getAllEmails } from "layouts/dashboard/_request";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";

export default function EmailModal({ setSelectedValue, selectedValue, resetOTP }) {
  const [emails, setEmails] = React.useState([]);

  const getAllCustomerEmails = async () => {
    try {
      const {
        data: { data, success },
      } = await getAllEmails();
      if (success) {
        setEmails(data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  React.useEffect(() => {
    getAllCustomerEmails();
  }, []);
  return (
    <Box sx={{ width: 300, mt: 2 }}>
      <FormControl sx={{ m: 0, width: 260 }}>
        <Select
          sx={{ height: 45 }}
          value={selectedValue}
          onChange={(event) => {
            setSelectedValue(event.target.value);
            resetOTP();
          }}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
        >
          <MenuItem value={""}>Choose an email to send the gift card</MenuItem>
          {emails.map((email, index) => {
            return (
              <MenuItem value={email} key={index}>
                {email}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}

EmailModal.propTypes = {
  setSelectedValue: PropTypes.any,
  selectedValue: PropTypes.string.isRequired,
  resetOTP: PropTypes.any,
};
